import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import type { BreakApi } from "@/Modules/Patients/Models/Api";
import type { Break } from "@/Modules/Patients/Models/Domain";

import { camel } from "@/Utils/Camelize";
import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const BreakTransformer: TransformerExtended<Break, BreakApi> = {
  ...DefaultTransformerGenerator<Break, BreakApi>(),

  toDomain(input: BreakApi) {
    return camel<BreakApi, Break>(input);
  },
};

export type BreakTransformerType = TransformerExtended<Break, BreakApi>;

export default BreakTransformer;
